export default __webpack_public_path__ + "static/media/card-rodeo.f32dbab9.png";